import { LitElement, html, css } from 'lit-element';
import { connect } from '../store/connect';
import { actions, selectors } from './';
//import { actions as appActions } from '../app';
import { actions as userActions, selectors as userSelectors } from '../user';
import { actions as notificationActions } from '../notification';

import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-grid';
import '@trumedianetworks/tmn-core-components/src/tmn-input';

class AccountResetPassword extends LitElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex: 1;
                    flex-flow: column;
                    max-width: 600px;
                    min-width: 400px;
                }
                :host([hidden]) {
                    display: none;
                }
                routed-button,
                tmn-button {
                    width: 100%;
                    max-width: 325px;
                }
                .logo {
                    height: 120px;
                }
                tmn-input {
                    width: 100%;
                }
                .app-name {
                    font-size: 1.2rem;
                    color: var(--app-primary-dark-color);
                }
            `,
        ];
    }

    static get properties() {
        return {
            username: {
                type: String,
            },
            authSite: {
                type: String,
            },
            token: {
                type: String,
            },
            newPass: {
                type: String,
            },
            newPass: {
                type: String,
            },
        };
    }

    render() {
        return this.token ? this.renderResetForm() : this.renderRequestForm();
    }

    renderRequestForm() {
        const { username = '', authSite = '' } = this;
        const routeData = { username, authSite };
        const loginRouteName = authSite ? 'login-site' : 'login';
        // todo review post password reset
        // console.log(loginRouteName);
        // todo eventually don't show sitename on the form if it is given by the route
        return html`
            <tmn-grid
                container
                direction="column"
                justify="center"
                alignContent="center"
                spacing="2">
                <tmn-grid item container justify="center">${this.renderLogo()}</tmn-grid>
                <tmn-grid item container justify="center"
                    ><span class="app-name">Admin Console Password Reset</span></tmn-grid
                >
                <tmn-grid item>
                    <tmn-input
                        @tmn-input-changed=${this.handleInputChanged}
                        placeholder="username"
                        name="username"
                        required
                        .value=${username}>
                    </tmn-input>
                </tmn-grid>
                <tmn-grid item>
                    <tmn-input
                        @tmn-input-changed=${this.handleInputChanged}
                        placeholder="sitename"
                        required
                        name="authSite"
                        .value=${authSite}>
                    </tmn-input>
                </tmn-grid>
                <tmn-grid
                    item
                    container
                    direction="row"
                    justify="center"
                    alignContent="center"
                    wrap="nowrap"
                    spacing="1">
                    <tmn-grid item sm="8">
                        <tmn-button
                            color="primary"
                            variant="contained"
                            @click=${this.requestResetPasswordLink}
                            >Send reset password link</tmn-button
                        >
                    </tmn-grid>
                    <tmn-grid item sm="4">
                        <routed-button name=${loginRouteName} .data=${routeData}>
                            Cancel
                        </routed-button>
                    </tmn-grid>
                </tmn-grid>
            </tmn-grid>
        `;
    }

    renderResetForm() {
        const { newPass = '', newPassConfirm = '' } = this;
        // todo eventually don't show sitename on the form if it is given by the route
        return html`
            <tmn-grid
                container
                direction="column"
                justify="center"
                alignContent="center"
                spacing="2">
                <tmn-grid item container justify="center">${this.renderLogo()}</tmn-grid>
                <tmn-grid item container justify="center"
                    ><span class="app-name">Reset Password</span></tmn-grid
                >
                <tmn-grid item>
                    <tmn-input
                        @tmn-input-changed=${this.handleInputChanged}
                        placeholder="new password"
                        name="newPass"
                        type="password"
                        required
                        .value=${newPass}>
                    </tmn-input>
                </tmn-grid>
                <tmn-grid item>
                    <tmn-input
                        @tmn-input-changed=${this.handleInputChanged}
                        placeholder="confirm new password"
                        type="password"
                        name="newPassConfirm"
                        required
                        .value=${newPassConfirm}>
                    </tmn-input>
                </tmn-grid>
                <tmn-grid
                    item
                    container
                    direction="row"
                    justify="center"
                    alignContent="center"
                    wrap="nowrap"
                    spacing="1">
                    <tmn-grid item>
                        <tmn-button color="primary" variant="contained" @click=${this.resetPassword}
                            >Reset Password</tmn-button
                        >
                    </tmn-grid>
                </tmn-grid>
            </tmn-grid>
        `;
    }
    // todo could refactor some of this to base component or to be outside of login/reset etc
    renderLogo() {
        return html`<img
            src="/assets/images/trumedia_networks.svg"
            alt="TruMedia Networks"
            class="logo" />`;
    }

    handleInputChanged(e) {
        const { target, detail } = e;
        this[target.name] = detail.value;
    }

    requestResetPasswordLink(e) {
        const { username = '', authSite = '' } = this;
        if (!(username && authSite)) {
            this.actions.showSnackbar({
                snackbarMessage: `Username and sitename are required.`,
                snackbarType: 'error',
            });
            return;
        }
        this.actions.setActiveAuthSite({ activeAuthSite: authSite });
        this.actions.requestResetAccountPassword(username, authSite);
    }

    resetPassword(e) {
        const { newPass, newPassConfirm, token, authSite } = this;
        if (!authSite) {
            this.actions.showSnackbar({
                snackbarMessage: `Site is missing.`,
                snackbarType: 'error',
            });
            return;
        }
        if (!token) {
            this.actions.showSnackbar({
                snackbarMessage: `Missing token.`,
                snackbarType: 'error',
            });
            return;
        }
        if (!(newPass && newPassConfirm) || newPass !== newPassConfirm) {
            this.actions.showSnackbar({
                snackbarMessage: `Password and confirmation must match.`,
                snackbarType: 'error',
            });
            return;
        }
        if (newPass.length < 8) {
            this.actions.showSnackbar({
                snackbarMessage: `Password must be at least 8 characters.`,
                snackbarType: 'error',
            });
            return;
        }
        this.actions.resetAccountPassword({ password: newPass, token, authSite });
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            authSite: userSelectors.activeAuthSiteNameSelector(state),
            token: selectors.passwordTokenSelector(state),
        };
    };
};

const combinedActions = {
    ...actions,
    ...userActions,
    ...notificationActions,
};

customElements.define(
    'account-reset-password',
    connect(mapStateToProps, combinedActions)(AccountResetPassword)
);
